import axios from "axios";

const API = process.env.REACT_APP_API_URL;
const syncedMessageIds = new Set();

/** Guarda en libreta los contactos de un mensaje (una vez por gmailId por sesión). */
export function syncAddressBookFromMessage(gmailId, fields = {}) {
  const id = String(gmailId || "").trim();
  if (!id || syncedMessageIds.has(id)) return;
  syncedMessageIds.add(id);

  void axios
    .post(`${API}/emails/contacts/saved/sync`, {
      from: fields.from || "",
      to: fields.to || "",
      cc: fields.cc || "",
      bcc: fields.bcc || "",
    })
    .catch(() => {
      syncedMessageIds.delete(id);
    });
}
